import { Tabs, Typography } from 'antd';

import { Error403Unauthorized } from '@app/components';
import { PREFIX } from '@app/constants/appPrefix';
import { shortName } from '@app/utils';

import {
  useEditClientService,
  useEditClientServiceEffects,
} from '@pages/Clients/EditClientService/hooks';

import '@pages/Clients/EditClientService/styles/EditClientService.desktop.scss';
import '@pages/Clients/EditClientService/styles/EditClientService.tablet.scss';

const { Text, Title } = Typography;

export const EditClientService = () => {
  const {
    contextHolder,
    handleTabClick,
    activeKey,
    isDesktop,
    isUnauthorized,
    initTabHandler,
    tabs,
    fetchClientService,
    serviceName,
  } = useEditClientService();

  useEditClientServiceEffects({ initTabHandler, fetchClientService });

  if (isUnauthorized) {
    return <Error403Unauthorized />;
  }

  return (
    <div className={`${PREFIX}edit-client-service ${PREFIX}global-tab-styles`}>
      {contextHolder}
      <div className="ant-tabs-nav">
        <Title level={4} className="mg-0">
          Услуга
        </Title>
        <Text strong>{shortName(serviceName.trim(), !isDesktop, 20)}</Text>
      </div>
      <Tabs
        type={isDesktop ? 'line' : 'card'}
        tabPosition={isDesktop ? 'left' : 'top'}
        items={tabs}
        onTabClick={handleTabClick}
        activeKey={activeKey}
      />
    </div>
  );
};
